import React, { Component } from 'react';

import './AirModalCarousel.css';
import { Modal, Spin } from 'antd';
import isFunction from 'lodash/isFunction';
import moment from 'moment';
import AirButton from '../AirButton';
import { ArrowLeftIcon, ArrowRightIcon, CloseIcon } from '../../icons';
import AirList from '../AirList';
import { inject, observer } from 'mobx-react';

@inject('commonStore')
@observer
export default class AirModalCarousel extends Component {
  constructor(props) {
    super(props);

    this.pageSize = 7;

    this.state = {
      items: [],
      currentPage: 1
    };
  }

  componentDidMount = () => {
    this.setState({ visible: this.props.visible, current: this.props.current, items: this.props.items });
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible });
    }

    if (this.props.current && prevState.current !== this.props.current) {
      this.setState({ current: this.props.current });
    }
  };

  show = () => {
    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({ current: 0, items: [] });
    if (isFunction(this.props.onCancel)) {
      this.props.onCancel();
    } else {
      this.setState({ visible: false });
    }
  };

  renderHeader = () => {
    return <div>header</div>;
  };

  renderContent = () => {
    if (isFunction(this.props.renderContent)) {
      if (this.props.items && this.state.current > -1) {
        return this.props.renderContent(this.props.items[this.state.current], this.state.current, this.props.items);
      }
    } else {
      return <div>{this.state.current}</div>;
    }
  };

  renderSideItem = (item, index, selected) => {
    if (isFunction(this.props.renderSideItem)) {
      this.props.renderSideItem(item, index, selected);
    } else {
      return (
        <div onClick={this.goTo(index)} className={`brick ${selected ? 'selected' : ''}`}>
          <div className="bg" />
          <div className="brickInner">
            <div>{index + 1}</div>
            <div> {new Date(item.startAt).toLocaleDateString()}</div>
            <div>{new Date(item.startAt).toLocaleTimeString([], {timeStyle: 'short'})}</div>
          </div>
        </div>
      );
    }
  };

  next = () => {
    let current;
    if (this.state.current === (this.props.items || []).length - 1) {
      current = 0;
    } else {
      current = this.state.current + 1;
    }
    const currentPage = Math.floor(current / this.pageSize) + 1;
    this.setState({ current, currentPage });
  };

  prev = e => {
    e.stopPropagation();
    let current;
    if (this.state.current === 0) {
      current = (this.props.items || []).length - 1;
    } else {
      current = this.state.current - 1;
    }
    const currentPage = Math.floor(current / this.pageSize) + 1;
    this.setState({ current, currentPage });
  };

  goTo = index => () => {
    if (index > -1 && index < (this.props.items || []).length) {
      this.setState({ current: index });
    }
  };

  render() {
    const carouselLeftButtonStyle = {
      display: (this.props.items || []).length <= 1 ? 'none' : undefined
    };
    const carouselRightButtonStyle = {
      display: (this.props.items || []).length <= 1 ? 'none' : undefined
    };

    return (
      <Modal
        width={this.props.width ? this.props.width + 160 : this.props.width}
        height={this.props.height}
        className="AirModalCarousel"
        onCancel={this.hide}
        visible={this.state.visible}
        footer={null}
        closable={false}
        centered={true}
      >
        <div className="AirModalCarouselInner" style={{ height: this.props.height || 'auto' }}>
          <div className="arrow left">
            <AirButton className="AirModalCarouselArrowButton" style={carouselLeftButtonStyle} icon={<ArrowLeftIcon />} onClick={this.prev} />
          </div>
          <div className="main">
            <div className="header">
              <div className="headerInner">{this.props.header()}</div>
              <div className="close" onClick={this.hide}>
                <CloseIcon />
              </div>
            </div>
            <Spin spinning={this.props.loading} tip={this.props.loadingMessage} wrapperClassName="AirModalCarouselAirListSpin">
              <div className="content">
                <div className="side">
                  <AirList
                    className="AirModalCarouselAirList"
                    paginationPosition="bottom"
                    pageSize={this.pageSize}
                    currentPage={this.state.currentPage}
                    dataSource={this.props.items || []}
                    renderItem={(item, index, currentPage) => this.renderSideItem(item, index, index === this.state.current, currentPage)}
                    onPageChange={currentPage => this.setState({ currentPage })}
                  />
                </div>
                <div className="contentInner">{this.renderContent()}</div>
              </div>
            </Spin>
          </div>
          <div className="arrow right">
            <AirButton className="AirModalCarouselArrowButton" style={carouselRightButtonStyle} icon={<ArrowRightIcon />} onClick={this.next} />
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirModalCarousel/AirModalCarousel.js